import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader, PKUrl, SidebarInfo, SidebarInfoColumn } from 'components';
import { useIgnoreErrorsWhen } from 'components/molecules/ComponentLoader/hooks';
import fetch from 'features/common/fetch';
import taskDetail from 'features/views/taskDetail';
import { getDetail } from 'features/views/taskDetail/selectors';
import { equalOrThreeDashes, mailToLink, phoneToLink } from 'utils';
import { getClientName } from 'utils/client';

const { getStringOrOneOf } = taskDetail.utils;
const { LOSE_COMISSION } = taskDetail.constants.TASK_TYPES;

export const SidebarClientInfo = () => {
	const taskDetail = useSelector(getDetail);

	const { taskTypeId, metadata = {}, client = {}, clientLoadedFromCcd, id } = taskDetail;
	const { common = {} } = metadata;
	const { id: partnerId, address = {} } = client;

	const name = getClientName(client);
	const street = getStringOrOneOf(address.street, address.streetNo);

	const ignoreErrorsForTaskDetailUserHasNoAccess = useIgnoreErrorsWhen({
		fetchStorePath: fetch.constants.urls.taskDetail,
		attributePath: ['metaData', 'parsedContent', 'status'],
		value: 403,
	});

	return (
		<ComponentLoader
			fetchStorePath={fetch.constants.urls.taskDetail}
			ignoreErrors={ignoreErrorsForTaskDetailUserHasNoAccess}
		>
			<SidebarInfo>
				<SidebarInfoColumn
					attribute={getLabelMessage('detail:asideBarName')}
					value={
						<PKUrl.PKPartner partnerId={clientLoadedFromCcd && partnerId} taskId={id} unlock muiLink>
							{equalOrThreeDashes(name)}
						</PKUrl.PKPartner>
					}
				/>
				<SidebarInfoColumn
					attribute={getLabelMessage('detail:asideBarBirthNumber')}
					value={equalOrThreeDashes(client.birthNumber)}
				/>
				<SidebarInfoColumn
					attribute={getLabelMessage('detail:asideBarBusinessIn')}
					value={equalOrThreeDashes(client.businessIn)}
				/>
				<SidebarInfoColumn
					attribute={getLabelMessage('detail:asideBarCity')}
					value={equalOrThreeDashes(address.municipality)}
				/>
				<SidebarInfoColumn
					attribute={getLabelMessage('detail:asideBarStreet')}
					value={equalOrThreeDashes(street)}
				/>
				<SidebarInfoColumn
					attribute={getLabelMessage('detail:asideBarPSC')}
					value={equalOrThreeDashes(address.zipCode)}
				/>
				<SidebarInfoColumn
					attribute={getLabelMessage('detail:asideBarPhone')}
					value={taskTypeId === LOSE_COMISSION ? equalOrThreeDashes() : phoneToLink(client.phone, true)}
				/>
				<SidebarInfoColumn
					attribute={getLabelMessage('detail:asideBarEmail')}
					value={taskTypeId === LOSE_COMISSION ? equalOrThreeDashes() : mailToLink(client.email, true)}
				/>
				<SidebarInfoColumn
					attribute={getLabelMessage('detail:asideBarContactPhone')}
					value={phoneToLink(
						common.phone || common.clientCellPhone || common.clientPhone || client.kclPhone,
						true,
					)}
				/>
				<SidebarInfoColumn
					attribute={getLabelMessage('detail:asideBarContactEmail')}
					value={mailToLink(common.email || common.clientEmail || client.kclEmail, true)}
				/>
			</SidebarInfo>
		</ComponentLoader>
	);
};

SidebarClientInfo.propTypes = {
	taskDetail: PropTypes.object,
};

export default SidebarClientInfo;
